/**
 * @generated SignedSource<<f67c3a0db02b4fdf6e9e243c506b8137>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
import { FragmentRefs } from "relay-runtime";
export type CalendarEvents_NoteStream$data = {
  readonly claimedEvents: ReadonlyArray<{
    readonly end: string | null;
    readonly lastRecurrenceEnd: string | null;
    readonly type: EventType;
    readonly " $fragmentSpreads": FragmentRefs<"CalendarEventsRecurringEventCard_Event" | "CalendarEventsSingleEventCard_Event">;
  }>;
  readonly " $fragmentType": "CalendarEvents_NoteStream";
};
export type CalendarEvents_NoteStream$key = {
  readonly " $data"?: CalendarEvents_NoteStream$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarEvents_NoteStream">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarEvents_NoteStream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "claimedEvents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastRecurrenceEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CalendarEventsSingleEventCard_Event"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CalendarEventsRecurringEventCard_Event"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "4f030058179953f847134d73c31cbac9";

export default node;
